import { render, staticRenderFns } from "./PreciosPlazas.vue?vue&type=template&id=b87c673a"
import script from "./PreciosPlazas.vue?vue&type=script&lang=js"
export * from "./PreciosPlazas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports